export class TheatreBasketPackMaterial {
  barcode: string;
  name: string;
  unitOfMeasure: string;
  packQuantity: number;
  availableQuantity: number;
  unavailable: boolean;
  packId: number;
  materialId: number;
  packBasketId: string;
  availableStock: number;
  userName: string;
}
